/* eslint-disable import/prefer-default-export */
import React from 'react';
import { costBasisCurrencyFormat, decimalFormatZeroToTwoDecimals, largeCurrencyFormat } from 'common/formats/formats';
import { GridDateEditor, GridDateValueViewer } from 'components/FeaturedSpreadsheet/components';
import { LedgerGridDate } from 'components/LedgerTable/components';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import InvestmentDateSelect from '../../../InvestmentDateSelect';
import { AMOUNT_ALIAS, COST_BASIS_ALIAS, PURCHASE_DATE_ALIAS, SHARES_ALIAS } from '../../constants';

type DateColConfigDefault = {
  dataEditor: (props: ICell) => React.ReactNode;
  gridDateComponent: typeof LedgerGridDate;
  valueViewer: (props: ICell) => React.ReactNode;
};

type DateColConfigCustom = {
  component: React.ReactNode;
  disableEvents: boolean;
  forceComponent: boolean;
};

export type DateColConfigProps = DateColConfigDefault | DateColConfigCustom;

export const colConfig = (
  investmentDates: string[],
  modeledAfterConvertibleNote = false,
  isCustomSecurity = false,
  isWarrantOrOption = false
) => {
  let dateColConfigProps: DateColConfigProps = {
    dataEditor: (props: ICell) => <GridDateEditor {...props} />,
    gridDateComponent: LedgerGridDate,
    valueViewer: (props: ICell) => <GridDateValueViewer {...props} />,
  };

  if (Array.isArray(investmentDates) && investmentDates.length > 1) {
    dateColConfigProps = {
      component: <InvestmentDateSelect investmentDates={investmentDates} />,
      disableEvents: true,
      forceComponent: true,
    };
  }

  const dateColConfig = {
    isRequired: true,
    sourceTable: 'purchased',
    value: 'Date',
    width: '175px',
    ...dateColConfigProps,
    alias: PURCHASE_DATE_ALIAS,
  };

  const amountColConfig = {
    alias: modeledAfterConvertibleNote ? AMOUNT_ALIAS : COST_BASIS_ALIAS,
    format: modeledAfterConvertibleNote ? largeCurrencyFormat : costBasisCurrencyFormat,
    maxDecimalDigits: modeledAfterConvertibleNote ? null : 2,
    gridType: 'number',
    isRequired: true,
    value: modeledAfterConvertibleNote ? 'Purchased Amount' : 'Cost Basis',
    width: '175px',
    ...(modeledAfterConvertibleNote || isWarrantOrOption ? null : { greaterThan: 0 }),
    minValue: isWarrantOrOption ? 0 : undefined,
  };

  if (modeledAfterConvertibleNote) {
    return [dateColConfig, amountColConfig];
  }

  const sharesColConfig = {
    alias: SHARES_ALIAS,
    format: decimalFormatZeroToTwoDecimals,
    gridType: 'number',
    isRequired: !isCustomSecurity,
    value: 'Shares',
    width: '175px',
    ...(!isCustomSecurity ? { minValue: 1 } : null),
  };

  return [dateColConfig, sharesColConfig, amountColConfig];
};
export default colConfig;
